import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  togglePortfolio(event) {
    this.element.dataset.photographer = event.target.checked
  }
}
